import { suggestionRoundsOf, type DecidedSuggestion as SharedDecidedSuggestion, type SuggestionRound as SharedSuggestionRound } from '@shared/upstream-deferral';
import type { TaskEvent } from '@shared/types/tasks';
import { showFoldingCard } from './folding-card';

/** A decision on one suggestion, and the message that made it. */
export type DecidedSuggestion = SharedDecidedSuggestion<TaskEvent>;

/**
 * One run's suggestions on a task (T-14), what people decided about each, and (T-58) which are out
 * upstream (`sent`) with Jev's picks from the replies there (`proposals`).
 */
export type SuggestionRound = SharedSuggestionRound<TaskEvent>;

/**
 * Every run's suggestions in a task's events (oldest first), newest round first. A decisions message
 * belongs to the round it names (roundForDecisions): "Suggestions from R-12 · 3f9a1c2e" that message of R-12's,
 * "Suggestions from R-12" R-12's newest before it, "Suggestions" the newest before it.
 */
export function suggestionRounds(events: TaskEvent[]): SuggestionRound[] {
  return suggestionRoundsOf(events).reverse();
}

/** True when every suggestion in the round has a decision. */
export const roundDecided = (round: SuggestionRound) => round.suggestions.suggestions.every((_s, i) => round.decided.has(i + 1));

/** The id of a task's Suggestions section (TaskSuggestions). */
export const suggestionsAnchorId = (taskId: string) => `task-suggestions-${taskId}`;

/** The id of one run's suggestions card, wherever it shows (To answer while undecided, Suggestions once decided). */
export const suggestionRoundId = (eventId: string) => `task-suggestion-${eventId}`;

/** Scrolls to a run's suggestions (the pointer line in the comments), opening them if folded; else to the Suggestions. */
export function showTaskSuggestions(taskId: string, eventId?: string) {
  if (eventId && showFoldingCard(suggestionRoundId(eventId))) return;
  document.getElementById(suggestionsAnchorId(taskId))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
